/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface Open360BusinessLogicRetailersAccountStoreManagerPagingSettings {
    PlaceID?: number;
    Keyword?: string;
    IsActive?: boolean;
    Limit?: number;
    Offset?: number;
    SortColumn?: string;
    /**
     * 0 = Ascending, 1 = Descending
     */
    SortOrder?: Open360BusinessLogicRetailersAccountStoreManagerPagingSettings.SortOrderEnum;
}
export namespace Open360BusinessLogicRetailersAccountStoreManagerPagingSettings {
    export type SortOrderEnum = 0 | 1;
    export const SortOrderEnum = {
        NUMBER_0: 0 as SortOrderEnum,
        NUMBER_1: 1 as SortOrderEnum
    }
}



// WEBPACK FOOTER //
// ./src/app.retailer/modules/model/open360BusinessLogicRetailersAccountStoreManagerPagingSettings.ts